module.exports = __webpack_public_path__ + "img/轮播1.66c9dfac.png";